// Traduções para tipos de propriedades e transações
export const propertyTypeTranslations: Record<string, string> = {
  // Residential
  'Residential / Apartment': 'Apartamento',
  'Residential / Home': 'Casa',
  'Residential / Condominium': 'Casa de Condomínio',
  'Residential / Penthouse': 'Cobertura',
  'Residential / Flat': 'Flat',
  'Residential / Studio': 'Studio',
  'Residential / Loft': 'Loft',
  'Residential / Duplex': 'Duplex',
  'Residential / Triplex': 'Triplex',
  'Residential / Quadruplex': 'Quadruplex',
  'Residential / Village House': 'Casa de Vila',
  'Residential / Farm': 'Chácara',
  'Residential / Farm Ranch': 'Fazenda',
  'Residential / Sobrado': 'Sobrado',
  'Residential / Land Lot': 'Terreno',

  // Commercial
  'Commercial / Building': 'Prédio Comercial',
  'Commercial / Office': 'Sala Comercial',
  'Commercial / Shop': 'Loja',
  'Commercial / Warehouse': 'Galpão',
  'Commercial / Industrial Shed': 'Barracão Industrial',
  'Commercial / Business Point': 'Ponto Comercial',

  // Others
  'Other': 'Outros'
};

export const transactionTypeTranslations: Record<string, string> = {
  'sale': 'Venda',
  'rent': 'Aluguel',
  'both': 'Venda/Aluguel'
};

// Mapeamento inverso para conversão de português para inglês
export const propertyTypeToEnglish: Record<string, string> = Object.entries(propertyTypeTranslations)
  .reduce((acc, [english, portuguese]) => {
    acc[portuguese] = english;
    return acc;
  }, {} as Record<string, string>);

export const transactionTypeToEnglish: Record<string, string> = Object.entries(transactionTypeTranslations)
  .reduce((acc, [english, portuguese]) => {
    acc[portuguese] = english;
    return acc;
  }, {} as Record<string, string>);

/**
 * Traduz tipo de propriedade do inglês para português
 */
export function translatePropertyType(englishType: string): string {
  return propertyTypeTranslations[englishType] || englishType;
}

/**
 * Traduz tipo de transação do inglês para português
 */
export function translateTransactionType(englishType: string): string {
  return transactionTypeTranslations[englishType] || englishType;
}

/**
 * Converte tipo de propriedade do português para inglês
 */
export function propertyTypeToEng(portugueseType: string): string {
  return propertyTypeToEnglish[portugueseType] || portugueseType;
}

/**
 * Converte tipo de transação do português para inglês
 */
export function transactionTypeToEng(portugueseType: string): string {
  const result = transactionTypeToEnglish[portugueseType] || portugueseType;
  console.log('🔄 Conversão transaction_type:', { input: portugueseType, output: result, mapping: transactionTypeToEnglish });
  return result;
}

// Traduções para características/amenidades
export const amenityTranslations: Record<string, string> = {
  // Piscinas
  'Pool': 'Piscina',
  'Heated Pool': 'Piscina aquecida',
  'Covered Pool': 'Piscina coberta',
  'Childrens Pool': 'Piscina infantil',
  'Adult Pool': 'Piscina para adulto',
  'Private Pool': 'Piscina privada',
  'Semi Olympic Pool': 'Piscina semi-olímpica',
  'Pool Bar': 'Bar na piscina',
  'Reflective Pool': 'Espelhos d\'água',

  // Esportes e Lazer
  'Gym': 'Academia',
  'Playground': 'Playground',
  'Toys Place': 'Brinquedoteca',
  'Recreation Area': 'Área de lazer',
  'Game room': 'Sala de jogos',
  'Party Room': 'Salão de festas',
  'BBQ': 'Churrasqueira',
  'Gourmet Area': 'Área gourmet',
  'Tennis Court': 'Quadra de tênis',
  'Football Field': 'Campo de futebol',
  'Indoor Soccer': 'Futebol indoor',
  'Volleyball Court': 'Quadra de vôlei',
  'Basketball Court': 'Quadra de basquete',
  'Multi Sport Court': 'Quadra poliesportiva',
  'Jogging track': 'Pista de cooper',
  'Skate Lane': 'Pista de skate',
  'Sand Pit': 'Tanque de areia',
  'Fitness Room': 'Sala de fitness',

  // Segurança
  'Security Guard on Duty': 'Segurança 24h',
  'Security Camera': 'Câmera de segurança',
  'TV Security': 'Circuito de segurança',
  'Concierge 24h': 'Portaria 24h',
  'Armored Security Cabin': 'Guarita blindada',
  'Fenced Yard': 'Condomínio fechado',
  'Patrol': 'Ronda/Vigilância',

  // Serviços
  'Elevator': 'Elevador',
  'Generator': 'Gerador',
  'Caretaker': 'Zelador',
  'Valet Parking': 'Manobrista',
  'Guest Parking': 'Estacionamento de visitantes',
  'Reception room': 'Recepção',
  'Entrance Hall': 'Hall de entrada',
  'Disabled Access': 'Acesso para deficientes',

  // Tecnologia
  'Smart Condominium': 'Condomínio inteligente',
  'Intercom': 'Interfone',
  'Eco Condominium': 'Condomínio ecológico',
  'Eco Garbage Collector': 'Coleta seletiva',

  // Relaxamento
  'Sauna': 'Sauna',
  'Zen Space': 'Espaço zen',
  'Solarium': 'Solarium',
  'Green space / Park': 'Área verde / Parque',
  'Orchid Place': 'Orquidário',
  'Pomar': 'Pomar',

  // Específicos corrigidos
  'Pet Space': 'Pet Place',
  'Meeting Room': 'Sala de Reunião',
  'Bicycles Place': 'Bicicletário',

  // Conveniência
  'Square': 'Praça',
  'Close to schools': 'Próximo a escolas',
  'Close to hospitals': 'Próximo a hospitais',
  'Close to public transportation': 'Próximo ao transporte público',
  'Close to main roads/avenues': 'Próximo a vias principais',
  'Varanda Gourmet': 'Varanda gourmet',
  'Cozinha Planejada': 'Cozinha planejada',
  'Varanda': 'Varanda',
  'Ar Condicionado': 'Ar condicionado',
  'Armários Embutidos': 'Armários embutidos'
};

// Mapeamento inverso para conversão de português para inglês
export const amenityTranslationsToEnglish: Record<string, string> = Object.entries(amenityTranslations)
  .reduce((acc, [english, portuguese]) => {
    acc[portuguese] = english;
    return acc;
  }, {} as Record<string, string>);

/**
 * Traduz amenidade/característica do inglês para português
 */
export function translateAmenity(englishAmenity: string): string {
  return amenityTranslations[englishAmenity] || englishAmenity;
}

/**
 * Traduz amenidade/característica do português para inglês (para portais OLX)
 */
export function translateAmenityToEnglish(portugueseAmenity: string): string {
  return amenityTranslationsToEnglish[portugueseAmenity] || portugueseAmenity;
}

/**
 * Traduz múltiplas amenidades do inglês para português
 */
export function translateAmenities(amenities: string[]): string[] {
  return amenities.map(amenity => translateAmenity(amenity));
}

/**
 * Traduz múltiplas amenidades do português para inglês (para portais OLX)
 */
export function translateAmenitiesToEnglish(amenities: string[]): string[] {
  return amenities.map(amenity => translateAmenityToEnglish(amenity));
}
